import { CircularProgress } from '@material-ui/core'
import React ,{useEffect} from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import RatinigClient from '../../Utilitis/RatinigClient'
import Section from '../../Utilitis/Section'
import SingalHeader from '../../Utilitis/SingalHeader'
import Teacher from '../../Utilitis/Teacher/Teacher'
import TeacherSkill from './Component/TeacherSkill'
import { motion } from 'framer-motion';
import { SingalProfile, TeacherDescription ,PersonalInfo} from './Style'

export default function SingalTeacher() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "100%" }}
                transition={{ duration: 0.3 }}
            >
                <SingalHeader title="Singal Teacher" />
                <Section bg="#f3f7f9">
                    <Container>
                        <SingalProfile>
                            <Row>
                                <Col lg={6} md={12} sm={12} xs={12}>
                                    <div>
                                        <img src={"/images/teacher_1.jpg"} />
                                    </div>
                                </Col>
                                <Col lg={6} md={12} sm={12} xs={12} >
                                    <TeacherDescription>
                                        <h6>Jhone ado</h6>
                                        <p>Master of Education Degree</p>
                                        <RatinigClient />
                                        <h6>Description</h6>
                                        <p>
                                            Enthusa expedte clent focused
                                            growth strateg wherea clent
                                            centered infrastruct ntrinsicl
                                            grow optimal talers rather than efectve
                                            nformaon Collabora optimize partnersh and
                                            frictionles deliverables infrastructs ntrinsicl
                                            grow optimal talers rather efectve
                                        </p>
                                        <h6>Personal Info</h6>
                                        <PersonalInfo>
                                            <p>
                                                growth strateg wherea clent
                                                centered infrastruct ntrinsicl
                                                grow optimal talers rather than efectve
                                                nformaon Collabora optimize partnersh and
                                            </p>
                                            <div>
                                                <i className="fas fa-user"></i>
                                                <span>Adress</span>
                                                <span>: Jhone@gmail.com</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-user"></i>
                                                <span>Email</span>
                                                <span>: Jhone@gmail.com</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-user"></i>
                                                <span>Phone</span>
                                                <span>: Jhone@gmail.com</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-user"></i>
                                                <span>website</span>
                                                <span>: Jhone@gmail.com</span>
                                            </div>
                                            <div>
                                                <i className="fas fa-user"></i>
                                                <span>Degree </span>
                                                <span>: Jhone@gmail.com</span>
                                            </div>
                                        </PersonalInfo>
                                    </TeacherDescription>
                                </Col>
                            </Row>
                        </SingalProfile>
                        <TeacherSkill />
                    </Container>
                </Section>
            </motion.div>
        </>
    )
}
